import { useAiAgents } from '@/data/aiAgent';
import { Loading } from '@/components/ui/loading';
import { Error } from '@/components/ui/error';
import { Card, CardDescription, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';

const CONTEXT_LABELS = {
  estimate: 'Estimate',
  comparison: 'Comparison',
  'consolidated-estimate': 'Consolidated Estimate'
};

const ListAiAgents = () => {
  const aiAgents = useAiAgents();

  if (aiAgents.isLoading && !aiAgents.data) {
    return <Loading />;
  }

  if (aiAgents.error) {
    return <Error message="An error occurred loading AI agents" />;
  }

  const agents = aiAgents.data.query.map((uid) => aiAgents.data.content[uid]);

  const categories = [];
  const categoryMap = {};
  agents.forEach((agent) => {
    const categoryUid = agent.ai_agent_category?.uid;
    if (!categoryUid) return;
    if (!categoryMap[categoryUid]) {
      categoryMap[categoryUid] = {
        ...agent.ai_agent_category,
        agents: []
      };
      categories.push(categoryMap[categoryUid]);
    }
    categoryMap[categoryUid].agents.push(agent);
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>AI Agents</CardTitle>
        <CardDescription>System AI agents available across all companies. This is a read-only reference list.</CardDescription>
      </CardHeader>

      <CardContent className="space-y-6">
        {categories.map((category) => (
          <div key={category.uid}>
            <h3 className="text-lg font-semibold mb-2">{category.label}</h3>
            <p className="text-sm text-muted-foreground mb-3">{category.description}</p>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Title</TableHead>
                  <TableHead>Type</TableHead>
                  <TableHead>Description</TableHead>
                  <TableHead>Contexts</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {category.agents.map((agent) => (
                  <TableRow key={agent.uid}>
                    <TableCell className="font-medium">{agent.title}</TableCell>
                    <TableCell className="font-mono text-sm">{agent.type}</TableCell>
                    <TableCell className="text-muted-foreground">{agent.description}</TableCell>
                    <TableCell>
                      <div className="flex gap-1 flex-wrap">
                        {agent.contexts?.map((context) => (
                          <Badge key={context} variant="secondary">
                            {CONTEXT_LABELS[context] || context}
                          </Badge>
                        ))}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default ListAiAgents;
